import { useCallback } from 'react';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { EscalationPolicyForm } from './escalation-policy-form';
import { POLICY_CATEGORY_ESCALATION } from './policy-constants';
import { SupportPolicyForm, SupportPolicyFormValues } from './policy-form';

export const SupportPolicyModal = () => {
  const { modalProps } = useModalState(Modals.SupportPolicyModal);
  const { closeModal } = useModalMethods(Modals.SupportPolicyModal);

  const handleSave = useCallback(
    (values: SupportPolicyFormValues) => {
      modalProps?.onSave?.(values, modalProps?.policy ?? null);
      closeModal();
    },
    [closeModal, modalProps],
  );

  const policy = modalProps?.policy ?? undefined;

  return policy?.category === POLICY_CATEGORY_ESCALATION ? (
    <EscalationPolicyForm policy={policy} onSave={handleSave} onClose={closeModal} />
  ) : (
    <SupportPolicyForm policy={policy} onSave={handleSave} onClose={closeModal} />
  );
};
